import { getFluent2InputDisabledStyles, getFluent2InputFocusStyles } from './inputStyleHelpers.utils';
export function getSearchBoxStyles(props) {
    var hasFocus = props.hasFocus, underlined = props.underlined, disabled = props.disabled, theme = props.theme;
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var restBottomBorder = "1px solid ".concat(palette.neutralPrimary);
    var styles = {
        root: [
            {
                borderRadius: underlined ? 0 : theme.effects.roundedCorner4,
                borderBottom: restBottomBorder,
            },
            hasFocus && [
                'is-active',
                {
                    position: 'relative',
                    borderColor: 'unset',
                },
                getFluent2InputFocusStyles(theme),
            ],
            disabled && [
                'is-disabled',
                getFluent2InputDisabledStyles(theme),
                { borderBottom: "1px solid ".concat(semanticColors.disabledBorder) },
            ],
        ],
        field: [
            disabled && {
                '::placeholder': {
                    color: semanticColors.disabledText,
                },
            },
        ],
        iconContainer: [
            {
                color: theme.palette.neutralPrimary,
            },
            disabled && [
                'is-disabled',
                {
                    color: semanticColors.disabledText,
                },
            ],
        ],
    };
    return styles;
}
//# sourceMappingURL=SearchBox.styles.js.map